import { getFilterIndicator } from "../helpers";

import type { FilterStrategy } from "./types";

export const textStrategy: FilterStrategy = {
  search(filterType, ctx, out) {
    const labelLower = filterType.label.toLowerCase();
    const queryWords = ctx.query.split(/\s+/).filter((w) => w.length > 0);
    const matchesFilterName =
      labelLower.includes(ctx.query) ||
      queryWords.some((word) => labelLower.includes(word));
    const isPurelyNumeric = /^\d+\.?\d*$/.test(ctx.trimmedQuery);
    if (matchesFilterName || isPurelyNumeric || ctx.matchesAnyIdPrefix) return;
    const textScore = ctx.looksLikeDate ? 5 : ctx.looksLikeNumber ? 15 : 20;
    out.push({
      filterKey: filterType.filterKey,
      filterLabel: filterType.label,
      optionValue: ctx.trimmedQuery,
      optionLabel: `~ "${ctx.trimmedQuery}"`,
      type: filterType.type,
      score: textScore,
      indicator: getFilterIndicator(filterType, false, true),
    });
  },
  isSelected(currentValue, optionValue) {
    return currentValue === optionValue;
  },
  toggle(result) {
    return { value: result.optionValue, clearSearchQuery: true };
  },
};
